<template>
  <SingleSelect
    v-model="adaptedValue"
    :searchable="false"
    :items="selectItems"
    :label="$t('components.filters.SortingFilter.label')"
    :rules="rules"
    dense
    outlined
  >
    <template v-slot:selection="{item}">
      <span class="filter__summary text--disabled">
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from '@/components/filter/models/SingleSelect';
import { SORTING } from '@/services/charts-service';

export default {
  name: 'SortingFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    adaptedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    selectItems() {
      return [{
        text: this.$t('components.filters.SortingFilter.items.asc'),
        value: SORTING.ASC,
      },
      {
        text: this.$t('components.filters.SortingFilter.items.desc'),
        value: SORTING.DESC,
      }];
    },
  },
};

</script>

<style scoped lang="scss">
.filter__summary {
  margin-left: var(--ds-spacing-inline-nano);
}
</style>
